import type { HomeFile } from 'reactApp/modules/home/home.types';
import type { IPopupHelperProps } from 'reactApp/modules/popup/popup.helpers';
import type { PublicFile } from 'reactApp/modules/public/public.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export type CreateCopyOfNonEditableFileModalProps = Pick<IPopupHelperProps, 'onClose'> & {
    file: HomeFile | PublicFile;
    editingNoneEditableFormats: { storage: EStorageType; ext: string };
    fromSharePopup?: boolean;
};

export const enum ContentType {
    home = 'home',
    sharedHome = 'sharedHome',
    sharedPopup = 'sharedPopup',
}
